import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, AfterViewInit, Input, Output, HostListener } from '@angular/core';
import { DatePipe, formatDate, formatNumber } from '@angular/common';
import { concat, tap, from, Subject, Subscription } from 'rxjs';
import { map, filter, switchMap, concatMap, debounceTime, finalize } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';

import { Client, CustomerCategory } from 'src/app/shared/client';
import { ClientApiService } from 'src/app/services/client-api.service';
import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'

@Component({
  selector: 'app-edit-client-departments',
  templateUrl: './edit-client-departments.component.html',
  styleUrls: ['./edit-client-departments.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditClientDepartmentsComponent implements OnInit, OnDestroy, OnChanges {

  globalSettinsData: GlobalSettingsData;

  @Input() clientId: number;

  @ViewChild('departmentTable') departmentTable: Table;

  loading: boolean = false;
  rowIndex: number = 0;
  editMode: boolean = false;
  totalRecords: number = 0;
  rows: number = 10;

  fvCLIENTSNIKNAME: string;
  fvCLIENTSNAME: string;
  fvCLICATEGORY: string;

  confirmDeleteOn: boolean = false;
  typeDeleteConfirmation: boolean = true;
  confirmText: string = 'DELETE THIS';
  deleteMessageText: string;

  company: Client = null;
  companyGroup: CustomerCategory = null;

  mainCompanyDepartmentList: Client[] = [];

  departmentList: Client[] = [];
  departmentCloneList: Client[] = [];

  selectedDepartment: Client = null;

  private _departmentQuery: Subscription = null;
  private _departmentEditQuery: Subscription = null;
  private _departmentDeleteQuery: Subscription = null;

  private client$: Subject<number> = new Subject();

  public get noItems(): boolean { return ((this.departmentList || []).length < 1); }
  public get cannotCopyFromMain(): boolean { return this.company && this.company.CASTCATID && this.companyGroup && (this.company.CLIENTSNIKNAME == this.companyGroup.CASTCATNAME); }

  constructor(
    private cliApi: ClientApiService,
    private router: Router,
    private messageService: MessageService,
    private globalsettingsservice: GetglobalsettingsService,
  ) {

    this._departmentQuery =
      this.client$.pipe(
        debounceTime(100),

        tap(cliId => {
          environment.production || console.log('*** EditClientDepartmentsComponent client$ subscribing....: ' + cliId)
          this.loading = true;
        }),

        switchMap(cliid => this.cliApi.getDepartmentsByClientId(cliid).pipe(
          map(pl => {
            this.departmentList = pl;
            this.totalRecords = this.departmentList.length;
            pl.forEach(pr => (pr.cloneIndex = 0));
          }),

          concatMap(() => this.cliApi.getClientById(this.clientId).pipe(
            filter(cg => (cg != null) && (cg.length > 0)),
            map(cg => cg[0]),
            map(cg => {
              this.company = cg;
              environment.production || console.log('*** EditClientDepartmentsComponent loaded company: ' + JSON.stringify(this.company));
            })
          )),
          filter(() => (this.company != null) && (this.company.CASTCATID != null)),

          concatMap(() => this.cliApi.getCustomerCategoryByID(this.company.CASTCATID).pipe(
            filter(cg => (cg != null) && (cg.length > 0)),
            map(cg => cg[0]),
            map(cg => {
              this.companyGroup = cg;
              environment.production || console.log('*** EditClientDepartmentsComponent loaded companyGroup: ' + JSON.stringify(this.companyGroup));
            })
          )),

          // Here we need to find Id of main company to copy departments from

          concatMap(() => this.cliApi.getMainIdByClientId(this.clientId)),
          tap(mc => environment.production || console.log('*** EditClientDepartmentsComponent loaded main company id: ' + JSON.stringify(mc))),

          filter(mainCompany => (mainCompany != null) && (mainCompany.length >0)),
          map(mainCompany => mainCompany[0]),

          // Now load departments of main company
          concatMap(mainCompany => this.cliApi.getDepartmentsByClientId(mainCompany.CLIID).pipe(
            tap(md => environment.production || console.log('*** EditClientDepartmentsComponent loaded main company departments: ' + JSON.stringify(md))),

            filter(md => (md != null) && (md.length > 0)),
            map(md => {
              this.mainCompanyDepartmentList = md;
              environment.production || console.log('*** EditClientDepartmentsComponent loaded mainCompanyDepartmentList: ' + JSON.stringify(this.mainCompanyDepartmentList));
            })
          )),

          finalize(() => {
            this.loading = false;
          })
        ))
      )
        .subscribe();
  }

  ngOnDestroy(): void {
    console.log('*** EditClientDepartmentsComponent in ngOnDestroy')

    if (this._departmentQuery) { this._departmentQuery.unsubscribe(); }

    if (this._departmentEditQuery) { this._departmentEditQuery.unsubscribe(); }

    if (this._departmentDeleteQuery) { this._departmentDeleteQuery.unsubscribe(); }

  }

  loadClientInformation() {
    this.client$.next(this.clientId);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** EditClientDepartmentsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];
      console.log('*** EditClientDepartmentsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'clientId':
          this.loadClientInformation();
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** EditClientDepartmentsComponent ngOnInit:');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.loadClientInformation();
  }

  onRowSelect(event) {
    console.log('*** EditClientDepartmentsComponent onRowSelect: ' + JSON.stringify(event.data));
  }

  onRowUnselect(event) {
    console.log('*** EditClientDepartmentsComponent onRowUnselect: ' + JSON.stringify(event));
  }

  reloadDocContent(event) {
    console.log('*** EditClientDepartmentsComponent reloadDocContent: ' + JSON.stringify(event));

    this.loadClientInformation();
  }

  onRowsOptionChange(event) {
    //  console.log('*** EditDocumentContentComponent in doChangeConditions: ' + JSON.stringify(event));
    //  console.log('*** EditDocumentContentComponent in doChangeConditions (showRowOptions): ' + JSON.stringify(this.showRowOptions));
  }

  onAddRow(event) {
    console.log('*** EditClientDepartmentsComponent in onAddRow: ' + JSON.stringify(event));

    this.departmentList = [...this.departmentList, {
      CLIID: -2,
      CLISUBSOF: this.clientId,
      CLIENTSNAME: null,
      CLIENTSNIKNAME: null,
      CASTCATID: null,

      CLEINTBANKCITY: null,
      CLENTBANKADDR2: null,
      CLICATEGORY: 0,
      CLIDOCINDEX: null,
      CLIENTACCOUNT: null,
      CLIENTADDR1: null,
      CLIENTADR2: null,
      CLIENTBANK: null,
      CLIENTBANK2ACC: null,
      CLIENTBANKADDR1: null,
      CLIENTBANKCODE: null,
      CLIENTBANKPHONE: null,
      CLIENTBANKREGCODE: null,
      CLIENTBANKZIP: null,
      CLIENTCITY: null,
      CLIENTCOUNTRY: null,
      CLIENTNOTE1: null,
      CLIENTNOTE2: null,
      CLIENTREGCODE: null,
      CLIENTVATREGCODE: null,
      CLIENTVATREGNUM: null,
      CLIENTZIP: null,
      CLILOGOID: null,
      CLISTAMPID: null,
      CURID: null,
      cloneIndex: 0
    }];

    // environment.production || console.table(this.docItems);

    let ppe: Client = this.departmentList.find(e => e.CLIID == -2);
    this.onDiRowEditInit(ppe);
    this.departmentTable.initRowEdit(ppe);
  }

  // Check existance of same department in the list in main company

  checkExistenceOnTop(esg: Client): boolean {
    return (
      this.company
        && this.company.CASTCATID
        && this.mainCompanyDepartmentList
        && this.mainCompanyDepartmentList.some(mcd => (mcd.CLIENTSNIKNAME == esg.CLIENTSNIKNAME) && (mcd.CLIENTSNAME == esg.CLIENTSNAME))
    );
  }

  onDiRowEditInit(esg: Client) {
    console.log('*** EditClientDepartmentsComponent in onPpRowEditInit: entry');
    //environment.production || console.table(esg);

    let newCloneIndex: number = 0;

    /*
     * Quite tricky algoritm:
     * Because we can edit simultaneously more than one row in the table.
     * Therefore for every edited row we have to create cloned copy in shadow array [securityGroupsClone]
     * We can't predict the order of starting and ending the edit process
     * 
     * So - Search for max cloneIndex in current table and assign +1 to newly created row copy
     *
     * When row either cancelled or saved - clone index resetted to 0, clone copy deleted from shadow array
     *
     */
    this.departmentList.forEach(pp => { newCloneIndex = Math.max(newCloneIndex, pp.cloneIndex) });

    console.log('*** EditClientDepartmentsComponent in onPpRowEditInit: newCloneIndex is: ' + newCloneIndex);

    esg.cloneIndex = ++newCloneIndex;
    this.departmentCloneList.push({ ...esg });

    this.editMode = true;
  }

  onExtendedEdit(esg: Client) {
    console.log('*** EditClientDepartmentsComponent in onExtendedEdit: ' + JSON.stringify(esg));
  }

  onDiRowEditCancel(esg: Client, index: number) {
    console.log('*** EditClientDepartmentsComponent in onPpRowEditCancel: ' + index);
    //environment.production || console.table(esg);

    let ppid = this.departmentCloneList.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    if (esg.CLIID == -2) {
      // Cancel the newly created record
      // simply delete

      this.departmentList.splice(index, 1);

    } else {
      // Cancel editing of existing record
      // have to reload it from database

      this.departmentList[index] = { ...this.departmentCloneList[ppid] };
      this.departmentList[index].cloneIndex = 0;
    }

    this.departmentCloneList.splice(ppid, 1);

    this.editMode = false;
  }

  onDiRowEditSave(esg: Client) {
    console.log('*** EditClientDepartmentsComponent in onRowEditSave: ');
    environment.production || console.table(esg);

    let ppid = this.departmentCloneList.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    this._departmentEditQuery =
      // postClientById still emits the full Client entity (Observable<Client>) while
      // putClientById emits a row count (Observable<number>, Prompt 13-F interim rule) --
      // the intermediate map(c => c.CLIID) unifies both ternary branches to
      // Observable<number> so the outer .pipe()/.subscribe() below type-checks.
      ((esg.CLIID == -2) ? this.cliApi.postClientById(esg).pipe(map(c => c.CLIID)) : this.cliApi.putClientById(esg))
        .pipe(map((count) => {
          console.log('*** EditClientDepartmentsComponent in onSubscribe to Save: ' + count);

          this.departmentCloneList.splice(ppid, 1);
          esg.cloneIndex = 0;
          this.reloadDocContent(null);
          this.editMode = false;
        }))
        .subscribe();
  }

  onRemoveAllRow(event) {
    console.log('*** EditClientDepartmentsComponent in onRemoveAllRow: ' + JSON.stringify(event));

    if (!(this.editMode || this.noItems)) {
      this.confirmText = 'DELETE ALL';
      this.typeDeleteConfirmation = true;
      this.confirmDeleteOn = true;
    }
  }

  onDeleteConfirmation(event) {
    console.log('*** EditClientDepartmentsComponent onDeleteConfirmation: ' + JSON.stringify(event));

    if (event) {
      console.log('*** EditClientDepartmentsComponent DO DELETE!!! NOW!!!');

      this._departmentDeleteQuery =
        from(((this.confirmText == 'DELETE ALL')) ? this.departmentList : [this.selectedDepartment])
          .pipe(
            concatMap(data => this.cliApi.deleteClientById(data)),
            finalize(() => {
              this.confirmDeleteOn = false;
              this.reloadDocContent(null);
            })
          )
          .subscribe();

      //  if (this.confirmText == 'DELETE ALL') {

      //    this._departmentDeleteQuery =
      //      from(this.departmentList)
      //        .pipe(
      //          concatMap(data => this.cliApi.deleteClientById(data)),
      //          finalize(() => { 
      //            this.confirmDeleteOn = false;
      //            this.reloadDocContent(null);
      //          })
      //        )
      //        .subscribe();
      //  }
      //  else {
      //    this._departmentDeleteQuery =
      //      this.cliApi.deleteClientById(this.selectedDepartment)
      //        .pipe(
      //          finalize(() => {
      //            this.confirmDeleteOn = false;
      //            this.reloadDocContent(null);
      //          }))
      //        .subscribe();
      //  }
    }
  }

  onRemoveRow(event) {
    console.log('*** EditClientDepartmentsComponent in onRemoveRow: ' + JSON.stringify(event));

    if (!this.editMode && this.selectedDepartment) {
      this.confirmText = 'DELETE ' + this.selectedDepartment.CLIID;
      this.deleteMessageText = 'Вы собираетесь удалить контакт: ' + this.selectedDepartment.CLIENTSNIKNAME + '. Уверены?';

      this.typeDeleteConfirmation = true;
      this.confirmDeleteOn = true;
    }

  }

  copyDepartmentFromMain(event) {
    console.log('*** EditClientDepartmentsComponent in copyDepartmentFromMain: ' + JSON.stringify(event));

    if (!this.editMode && this.mainCompanyDepartmentList) {

      // Find department on main company that is not yet in current company and make the copy

      this.loading = true;
      this.mainCompanyDepartmentList.forEach(mcd => {
        let existInCurrent: boolean = this.departmentList.some(cd => (cd.CLIENTSNIKNAME == mcd.CLIENTSNIKNAME) && (cd.CLIENTSNAME == mcd.CLIENTSNAME));

        environment.production || console.log('*** EditClientDepartmentsComponent checking main company department: ' + mcd.CLIENTSNIKNAME + ' found: ' + existInCurrent);

        if (!existInCurrent) {
          this.departmentList = [...this.departmentList, {
            CLIID: -2,
            CLISUBSOF: this.clientId,
            CLIENTSNAME: mcd.CLIENTSNAME,
            CLIENTSNIKNAME: mcd.CLIENTSNIKNAME,
            CASTCATID: mcd.CASTCATID,

            CLEINTBANKCITY: null,
            CLENTBANKADDR2: null,
            CLICATEGORY: 0,
            CLIDOCINDEX: null,
            CLIENTACCOUNT: null,
            CLIENTADDR1: null,
            CLIENTADR2: null,
            CLIENTBANK: null,
            CLIENTBANK2ACC: null,
            CLIENTBANKADDR1: null,
            CLIENTBANKCODE: null,
            CLIENTBANKPHONE: null,
            CLIENTBANKREGCODE: null,
            CLIENTBANKZIP: null,
            CLIENTCITY: null,
            CLIENTCOUNTRY: null,
            CLIENTNOTE1: null,
            CLIENTNOTE2: null,
            CLIENTREGCODE: null,
            CLIENTVATREGCODE: null,
            CLIENTVATREGNUM: null,
            CLIENTZIP: null,
            CLILOGOID: null,
            CLISTAMPID: null,
            CURID: null,
            cloneIndex: 0
          }];

        }
      });

      environment.production || console.table(this.departmentList);

      from(this.departmentList.filter(d => d.CLIID == -2)).pipe(
        concatMap(dept => this.cliApi.postClientById(dept)),
        finalize(() => {
          this.reloadDocContent(null);
        })
      ).subscribe();
    }
  }
}
